import React from 'react';
import PropTypes from 'prop-types';
import HSL from '@haptik/helpers/build/esm/hslBuilder';
import { isProduction } from '@src/utils';

import './OutlierMessage.scss';

export default function OutlierMessage({
  value,
  onChange,
  // allPlatforms = []
}) {
  let outlierMessage = value && value.length ? value : [''];
  if (outlierMessage.asMutable) outlierMessage = outlierMessage.asMutable();
  return (
    <div className="outlier-message">
      <HSL
        value={outlierMessage}
        onChange={onChange}
        // allPlatforms={allPlatforms}
        disabled={isProduction()}
        withVariants
        withReplies
      />
    </div>
  );
}

OutlierMessage.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.arrayOf(PropTypes.string),
  allPlatforms: PropTypes.arrayOf(PropTypes.shape({})),
};

OutlierMessage.defaultProps = {
  onChange: () => {},
  value: [''],
  allPlatforms: [],
};
